import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import HeaderCart from '../HeaderCart';

export const Container = styled.div`
  display: unset; // weirdly needed for position: sticky; https://stackoverflow.com/a/60560997
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const StyledHeaderCart = styled(HeaderCart)`
  position: absolute;
  right: 20px;
  top: 20px;
`;

export const Title = styled.h2`
  ${MEDIA_QUERY.MOBILE} {
    display: none;
  }
  a {
    &:hover {
      text-decoration: none;
    }
  }
`;
